import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Images } from '../../config/images';
import './MarketHero.scss';

const MarketHero = () => {
  return (
    <div className='container-fluid'>
      <div className='markethero'>
        <div className='markethero__text'>
          <h2>The Realbricks Marketplace</h2>
          <p>
          Explore everything the Realbricks marketplace has to offer. As properties become available, you can choose investments that align with your long-term goals and potentially start building wealth.
          </p>
        </div>
        <div className='markethero__img'>
          <LazyLoadImage src={Images.hero} alt='The Realbricks Marketplace' />
        </div>
      </div>
    </div>
  );
};

export default MarketHero;
